import api from "./api";

// Operações admin do SaaS (somente Owner). Usa o MESMO apiClient de
// services/api.js — o token JWT é injetado pelo interceptor de request,
// e o 401 global já redireciona pro login. Não reinventa autenticação aqui.
//
// Convenção de erro: as mutações capturam o erro do axios e relançam um
// Error com `.message` PRONTA pra exibir no banner inline da página.
//   - 409 Conflict (alvo é Owner)  → message do corpo
//   - 404 Not Found (guia sumiu)    → message do corpo
//   - 403 Forbidden (não deveria    → mensagem genérica (só Owner chega aqui)
//     acontecer)
//   - 400 Bad Request (status inv.) → message do corpo

// Enum espelho do C# StatusGuia (ordem importa — serializado como número).
export const STATUS_GUIA = {
  Ativo: 0,
  Suspenso: 1,
  TrialExpirado: 2,
};

function toBannerError(err) {
  const status = err?.response?.status;
  const serverMsg = err?.response?.data?.message;
  if (status === 409) return new Error(serverMsg || "Operação não permitida.");
  if (status === 404) return new Error(serverMsg || "Guia não encontrado.");
  if (status === 403) return new Error("Acesso negado.");
  if (status === 400) return new Error(serverMsg || "Requisição inválida.");
  return new Error(serverMsg || "Falha ao conectar com o servidor.");
}

// GET /api/admin/guias — listagem paginada com filtros opcionais.
// Retorna PagedResultDto { items, page, pageSize, totalItems, totalPages }.
export async function listarGuias({ q, status, incluirDeletados, page, pageSize } = {}) {
  const params = {};
  if (q) params.q = q;
  if (status !== undefined && status !== null && status !== "") params.status = status;
  if (incluirDeletados) params.incluirDeletados = true;
  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;
  const { data } = await api.get("/admin/guias", { params });
  return data;
}

// GET /api/admin/metricas — contadores agregados pro painel.
export async function getMetricas() {
  const { data } = await api.get("/admin/metricas");
  return data;
}

// PATCH /api/admin/guias/{id}/status — body { status }.
export async function mudarStatus(id, status) {
  try {
    await api.patch(`/admin/guias/${id}/status`, { status });
  } catch (err) {
    throw toBannerError(err);
  }
}

// DELETE /api/admin/guias/{id} — soft-delete (seta DeletadoEm).
export async function softDelete(id) {
  try {
    await api.delete(`/admin/guias/${id}`);
  } catch (err) {
    throw toBannerError(err);
  }
}

// POST /api/admin/guias/{id}/restaurar — desfaz o soft-delete.
export async function restaurar(id) {
  try {
    await api.post(`/admin/guias/${id}/restaurar`);
  } catch (err) {
    throw toBannerError(err);
  }
}
